import { exec, getApiToken } from '../utils';
import type {
  RefreshAuthentication,
  RefreshAuthenticationArgs,
} from '@src/types';

export const refreshAuthentication = async ({ token }: RefreshAuthenticationArgs): Promise<RefreshAuthentication> => {
  const apiToken = await getApiToken(token);

  const query = `
    query refreshAuth(
      $token: String!
    ) {
      restUser(token: $token) {
        refreshAuth
      }
    }
  `;

  interface RestUserResponse {
    restUser: {
      refreshAuth: RefreshAuthentication;
    };
  }

  const data = await exec<{ token: string }, RestUserResponse>(
    query, {
      variables: {
        token: apiToken,
      },
    },
  );

  return data.restUser.refreshAuth;
};